
export class Pagination<T> {
    public data: Array<T> = [];
    public total: number;
    public count: number;
    public _links: any;

    constructor() {
        this.count = 5;
        this.total = 0;
    }
}
